"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverContent = PopoverContent;

var React = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _formatDollarValue = require("../utils/formatDollarValue");

var _formatConsumption = require("../utils/formatConsumption");

var _currency = require("../../../../../utils/currency");

const PopoverText = (0, _styledComponents.default)(_blocks.Main).attrs({
  as: 'div'
})`
  display: grid;
`;
const PopoverGrid = _styledComponents.default.p`
  display: grid;
  justify-content: space-between;
  grid-template-columns: auto auto;
  grid-column-gap: 16px;
`;
const ControlGroup = (0, _styledComponents.default)(_blocks.ControlGroup)`
  width: 100%;
  grid-auto-columns: auto;
`;

function PopoverContent({
  savings,
  projectKey
}) {
  var _savings$electricity, _savings$gas, _savings$thermal, _savings$water, _savings$totalImpact, _savings$operational;

  const elecSav = (_savings$electricity = savings.electricity) !== null && _savings$electricity !== void 0 ? _savings$electricity : 0;
  const gasSav = (_savings$gas = savings.gas) !== null && _savings$gas !== void 0 ? _savings$gas : 0;
  const thermalSav = (_savings$thermal = savings.thermal) !== null && _savings$thermal !== void 0 ? _savings$thermal : 0;
  const waterSav = (_savings$water = savings.water) !== null && _savings$water !== void 0 ? _savings$water : 0;
  const totalImpact = (_savings$totalImpact = savings.totalImpact) !== null && _savings$totalImpact !== void 0 ? _savings$totalImpact : 0;
  const operational = (_savings$operational = savings.operational) !== null && _savings$operational !== void 0 ? _savings$operational : 0;
  const elecFmt = (0, _formatConsumption.formatConsumption)(elecSav, _formatConsumption.MetricsType.Electricity);
  const gasFmt = (0, _formatConsumption.formatConsumption)(gasSav, _formatConsumption.MetricsType.Gas);
  const waterFmt = (0, _formatConsumption.formatConsumption)(waterSav, _formatConsumption.MetricsType.Water); // Thermal uses the same unit as electricity (kWh)

  const thermalFmt = (0, _formatConsumption.formatConsumption)(thermalSav, _formatConsumption.MetricsType.Electricity);
  const hasUtilityConsumption = elecSav > 0 || gasSav > 0 || waterSav > 0 || thermalSav > 0;
  const impactFmt = (0, _formatDollarValue.formatDollarValue)(totalImpact);
  const operationalFmt = (0, _formatDollarValue.formatDollarValue)(operational);
  const hasFinancialSavings = totalImpact > 0 || operational > 0;
  const currencySymbol = (0, _currency.useCurrencySymbol)(projectKey);
  return /*#__PURE__*/React.createElement(ControlGroup, {
    tight: true,
    vertical: true
  }, /*#__PURE__*/React.createElement(PopoverText, null, /*#__PURE__*/React.createElement("strong", {
    style: {
      fontWeight: 600
    }
  }, _core.i18n._({
    id: 'columns.estimated_savings',
    message: `Estimated Savings`
  }))), hasFinancialSavings && /*#__PURE__*/React.createElement(PopoverText, null, totalImpact > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.utility',
    message: 'Utility'
  })), /*#__PURE__*/React.createElement("span", null, currencySymbol, impactFmt)), operational > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.operational',
    message: 'Operational'
  })), /*#__PURE__*/React.createElement("span", null, currencySymbol, operationalFmt))), hasUtilityConsumption && /*#__PURE__*/React.createElement(PopoverText, null, elecSav > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.electricity',
    message: `Electricity`
  })), /*#__PURE__*/React.createElement("span", null, elecFmt.formattedTotalValue, " ", elecFmt.formattedUnit)), gasSav > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.gas',
    message: 'Gas'
  })), /*#__PURE__*/React.createElement("span", null, gasFmt.formattedTotalValue, " ", gasFmt.formattedUnit)), waterSav > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.water',
    message: 'Water'
  })), /*#__PURE__*/React.createElement("span", null, waterFmt.formattedTotalValue, " ", waterFmt.formattedUnit)), thermalSav > 0 && /*#__PURE__*/React.createElement(PopoverGrid, null, /*#__PURE__*/React.createElement("span", null, _core.i18n._({
    id: 'estimated_savings.thermal',
    message: 'Thermal'
  })), /*#__PURE__*/React.createElement("span", null, thermalFmt.formattedTotalValue, " ", thermalFmt.formattedUnit))));
}